import { createContext, useContext } from "react";
import { useTermsAndConditionsScript } from "../../hooks/useTermsAndConditionsInjectionScript";

const TermsAndConditionsContext = createContext(null);

export function TermsAndConditionsProvider({ children }) {
    const status = useTermsAndConditionsScript();

    return (
        <TermsAndConditionsContext.Provider value={status}>
            {children}
        </TermsAndConditionsContext.Provider>
    );
}

export function useTermsAndConditionsStatus() {
  const context = useContext(TermsAndConditionsContext);

  if (!context) {
    return { isLoading: false, isReady: false, isError: false };
  }

  const { isLoading, isReady, isError } = context;

  return { isLoading, isReady, isError };
}
